import React from 'react'
import { BetCard } from '@mobi/betslip/Components/Common/BetCard'
import { Details } from '@core/Areas/AccountActivity/Components/Ticket/Components/Details/Details'
import {
  getTicketLayoutType,
  getTicketStatus,
} from '@core/Areas/AccountActivity/Components/Ticket/helpers'
import type { TicketStatus } from '@core/Areas/AccountActivity/types'
import { InlineAlert } from '@mobi/betslip/Components/Common/InlineAlert'
import type { TicketShare as TicketShareType } from '@core/Areas/ShareBet/types'
import { TicketDisplayContext } from '@core/Areas/AccountActivity/context'
import { BetInfo } from '@core/Areas/AccountActivity/Components/Ticket/Components/BetInfo'
import { Investment } from '@core/Areas/AccountActivity/Components/Ticket/Components/Investment'

export const TicketShare: React.FC<{ share: TicketShareType['share']; isCostShared: boolean }> = ({
  share: { ticket, activeTab },
  isCostShared,
}) => {
  const ticketTypeLayout = getTicketLayoutType(ticket)

  const ticketStatus = getTicketStatus(ticket, activeTab)
  const ticketStatusProps = getTicketStatusProps(ticketStatus)

  return (
    <BetCard.Container
      topComponent={
        ticketStatusProps ? (
          <InlineAlert
            type={ticketStatusProps.type}
            text={ticketStatusProps.text}
            hasIcon={false}
            isCenterAlign
          />
        ) : null
      }
    >
      <TicketDisplayContext.Provider
        value={{
          type: 'share',
          data: { shouldHideCost: !isCostShared, display: 'external-share' },
        }}
      >
        <BetInfo ticket={ticket} status={ticketStatus} ticketLayoutType={ticketTypeLayout} />

        <Details ticket={ticket} />

        {isCostShared && <Investment status={ticketStatus} ticket={ticket} />}
      </TicketDisplayContext.Provider>
    </BetCard.Container>
  )
}

// =============
// Local Helpers
// =============

function getTicketStatusProps(
  status: TicketStatus
): Pick<React.ComponentProps<typeof InlineAlert>, 'text' | 'type'> | null {
  if (status === 'Pending') {
    return { text: 'PENDING', type: 'warning' }
  }

  if (status === 'Won') {
    return { text: 'WINNER', type: 'success' }
  }

  if (status === 'NoPayout') {
    return { text: 'NO PAYOUT', type: 'neutral' }
  }

  if (!status) return null

  return { text: status, type: 'neutral' }
}
